<div class="sidenav-content">
    <div class="bcontainer2">
        <div class="main-content">
            <div class="spacer2"></div>

            <div class="containter">
                <!-- Header -->
                <div class="page-header">
                    <div class="header-top">
                        <div class="header-title-section">
                            <i class="fa fa-angle-left back-icon" aria-hidden="true" (click)="goBack()"
                                title="Go back"></i>
                            <div>
                                <h1 class="page-title">
                                    <i class="fa-solid fa-apple-whole title-icon"></i>
                                    Nutrition
                                </h1>
                                <p class="page-subtitle">Logged meals and nutrient breakdown</p>
                            </div>
                        </div>

                        <div class="header-controls">
                            <div class="stats-badge" *ngIf="!loading">
                                <i class="fa-solid fa-bowl-food"></i>
                                <span>{{ totalEntries }} entries</span>
                            </div>
                            <div class="stats-badge cal-badge" *ngIf="!loading && filteredFood.length > 0">
                                <i class="fa-solid fa-fire"></i>
                                <span>{{ formatNum(pageCalories(), " kcal") }} this page</span>
                            </div>

                            <div class="view-toggle">
                                <button class="view-btn" [class.active]="viewMode === 'grid'"
                                    (click)="setViewMode('grid')" title="Grid view">
                                    <i class="fa-solid fa-grip"></i>
                                </button>
                                <button class="view-btn" [class.active]="viewMode === 'list'"
                                    (click)="setViewMode('list')" title="List view">
                                    <i class="fa-solid fa-list"></i>
                                </button>
                                <button class="view-btn" [class.active]="viewMode === 'compact'"
                                    (click)="setViewMode('compact')" title="Compact view">
                                    <i class="fa-solid fa-bars"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Controls -->
                    <div class="controls-bar">
                        <div class="search-box">
                            <i class="fa-solid fa-search search-icon"></i>
                            <input type="text" placeholder="Search food, notes (this page)..." [(ngModel)]="searchQuery"
                                (input)="onSearchChange()" class="search-input" />
                            <button class="clear-search-btn" *ngIf="searchQuery" (click)="clearSearch()"
                                title="Clear search">
                                <i class="fa-solid fa-times"></i>
                            </button>
                        </div>

                        <div class="control-group">
                            <div class="items-selector">
                                <label>Meal:</label>
                                <select [(ngModel)]="mealFilter" (change)="onMealFilterChange()" class="select-input">
                                    <option value="">All</option>
                                    <option value="breakfast">Breakfast</option>
                                    <option value="lunch">Lunch</option>
                                    <option value="dinner">Dinner</option>
                                    <option value="snack">Snack</option>
                                </select>
                            </div>

                            <div class="items-selector">
                                <label>Show:</label>
                                <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()"
                                    class="select-input">
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                                    <option [value]="50">50</option>
                                    <option [value]="100">100</option>
                                </select>
                            </div>

                            <div class="sort-selector">
                                <label>Sort:</label>
                                <select [(ngModel)]="sortBy" (change)="onSortChange()" class="select-input">
                                    <option value="date-desc">Newest First</option>
                                    <option value="date-asc">Oldest First</option>
                                    <option value="calories-desc">Most Calories</option>
                                    <option value="calories-asc">Fewest Calories</option>
                                    <option value="health-desc">Healthiest</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Results Summary -->
                <div class="results-summary" *ngIf="!loading && filteredFood.length > 0">
                    <span>Showing {{ getStartIndex() + 1 }}-{{ getEndIndex() }} of
                        {{ totalEntries }} entries</span>
                </div>

                <!-- Loading -->
                <div class="loading-container" *ngIf="loading">
                    <div class="spinner"></div>
                    <p>Loading food logs...</p>
                </div>

                <!-- Empty -->
                <div class="empty-state" *ngIf="!loading && filteredFood.length === 0">
                    <div class="empty-icon">
                        <i class="fa-solid fa-utensils"></i>
                    </div>
                    <h3 class="empty-title">No food logs found</h3>
                    <p class="empty-description">
                        Logged meals will appear here once they're recorded.
                    </p>
                </div>

                <!-- Food Grid/List -->
                <div class="food-container" [class.grid-view]="viewMode === 'grid'"
                    [class.list-view]="viewMode === 'list'" [class.compact-view]="viewMode === 'compact'"
                    *ngIf="!loading && filteredFood.length > 0">
                    <div class="food-card" *ngFor="let food of filteredFood; let i = index">
                        <!-- Header -->
                        <div class="card-header">
                            <div class="food-title">
                                <span class="food-name">{{ food?.foodName }}</span>
                                <span class="food-desc" *ngIf="food?.description">{{
                                    food.description
                                    }}</span>
                            </div>
                            <span class="meal-badge" [class.breakfast]="food?.mealType === 'breakfast'"
                                [class.lunch]="food?.mealType === 'lunch'" [class.dinner]="food?.mealType === 'dinner'"
                                [class.snack]="food?.mealType === 'snack'" *ngIf="food?.mealType">
                                {{ food.mealType }}
                            </span>
                        </div>

                        <!-- Calories + health -->
                        <div class="cal-row">
                            <div class="cal-block">
                                <span class="cal-value">{{ formatNum(food?.calories) }}</span>
                                <span class="cal-unit">kcal</span>
                            </div>
                            <div class="health-block">
                                <span class="health-pill" [class.good]="food?.isHealthy" [class.bad]="!food?.isHealthy"
                                    [title]="'Health score: ' + (food?.healthScore ?? 'n/a')">
                                    <i class="fa-solid" [class.fa-heart]="food?.isHealthy"
                                        [class.fa-heart-crack]="!food?.isHealthy"></i>
                                    {{ food?.isHealthy ? "Healthy" : "Less healthy" }}
                                    <ng-container *ngIf="food?.healthScore !== null && food?.healthScore !== undefined">
                                        · {{ food.healthScore }}</ng-container>
                                </span>
                            </div>
                        </div>

                        <!-- Macro bar -->
                        <div class="macro-section">
                            <div class="macro-bar">
                                <div class="macro-seg protein" [style.width.%]="macroPct(food, 'protein')"
                                    [title]="'Protein ' + protein(food) + 'g'"></div>
                                <div class="macro-seg carbs" [style.width.%]="macroPct(food, 'carbs')"
                                    [title]="'Carbs ' + carbs(food) + 'g'"></div>
                                <div class="macro-seg fat" [style.width.%]="macroPct(food, 'fat')"
                                    [title]="'Fat ' + fat(food) + 'g'"></div>
                            </div>
                            <div class="macro-legend">
                                <span class="macro-item">
                                    <span class="dot protein"></span>Protein
                                    <strong>{{ formatNum(protein(food), "g") }}</strong>
                                </span>
                                <span class="macro-item">
                                    <span class="dot carbs"></span>Carbs
                                    <strong>{{ formatNum(carbs(food), "g") }}</strong>
                                </span>
                                <span class="macro-item">
                                    <span class="dot fat"></span>Fat
                                    <strong>{{ formatNum(fat(food), "g") }}</strong>
                                </span>
                            </div>
                        </div>

                        <!-- Serving info -->
                        <div class="serving-row">
                            <span *ngIf="food?.servingSize">
                                <i class="fa-solid fa-weight-scale"></i>
                                {{ food.servingSize }}
                            </span>
                            <span *ngIf="food?.portionMultiplier">
                                <i class="fa-solid fa-xmark"></i>
                                {{ food.portionMultiplier }} portion
                            </span>
                            <span *ngIf="food?.caloriesFromFat">
                                <i class="fa-solid fa-droplet"></i>
                                {{ formatNum(food.caloriesFromFat) }} kcal from fat
                            </span>
                        </div>

                        <!-- Chips: benefits / warnings / allergens / dietary flags -->
                        <div class="chips-section" *ngIf="
                (food?.benefits && food.benefits.length) ||
                (food?.warnings && food.warnings.length) ||
                (food?.allergens && food.allergens.length) ||
                (food?.dietaryFlags && food.dietaryFlags.length)
              ">
                            <span class="chip benefit" *ngFor="let b of food?.benefits">
                                <i class="fa-solid fa-circle-check"></i> {{ b }}
                            </span>
                            <span class="chip warning" *ngFor="let w of food?.warnings">
                                <i class="fa-solid fa-triangle-exclamation"></i> {{ w }}
                            </span>
                            <span class="chip allergen" *ngFor="let a of food?.allergens">
                                <i class="fa-solid fa-wheat-awn"></i> {{ a }}
                            </span>
                            <span class="chip flag" *ngFor="let d of food?.dietaryFlags">
                                <i class="fa-solid fa-leaf"></i> {{ d }}
                            </span>
                        </div>

                        <!-- Detailed nutrients (vitamins / minerals / fiber etc.) -->
                        <div class="nutrient-details" *ngIf="
                hasObjData(food?.vitamins) ||
                hasObjData(food?.minerals) ||
                hasObjData(food?.dietaryFiber) ||
                hasObjData(food?.aminoAcids) ||
                hasObjData(food?.otherCompounds)
              ">
                            <div class="nutrient-group" *ngIf="hasObjData(food?.dietaryFiber)">
                                <div class="nutrient-group-title">Dietary Fiber</div>
                                <div class="nutrient-grid">
                                    <div class="nutrient-cell" *ngFor="let e of objEntries(food?.dietaryFiber)">
                                        <span class="n-label">{{ prettyLabel(e.key) }}</span>
                                        <span class="n-value">{{ e.value }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="nutrient-group" *ngIf="hasObjData(food?.vitamins)">
                                <div class="nutrient-group-title">Vitamins</div>
                                <div class="nutrient-grid">
                                    <div class="nutrient-cell" *ngFor="let e of objEntries(food?.vitamins)">
                                        <span class="n-label">{{ prettyLabel(e.key) }}</span>
                                        <span class="n-value">{{ e.value }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="nutrient-group" *ngIf="hasObjData(food?.minerals)">
                                <div class="nutrient-group-title">Minerals</div>
                                <div class="nutrient-grid">
                                    <div class="nutrient-cell" *ngFor="let e of objEntries(food?.minerals)">
                                        <span class="n-label">{{ prettyLabel(e.key) }}</span>
                                        <span class="n-value">{{ e.value }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="nutrient-group" *ngIf="hasObjData(food?.aminoAcids)">
                                <div class="nutrient-group-title">Amino Acids</div>
                                <div class="nutrient-grid">
                                    <div class="nutrient-cell" *ngFor="let e of objEntries(food?.aminoAcids)">
                                        <span class="n-label">{{ prettyLabel(e.key) }}</span>
                                        <span class="n-value">{{ e.value }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="nutrient-group" *ngIf="hasObjData(food?.otherCompounds)">
                                <div class="nutrient-group-title">Other Compounds</div>
                                <div class="nutrient-grid">
                                    <div class="nutrient-cell" *ngFor="let e of objEntries(food?.otherCompounds)">
                                        <span class="n-label">{{ prettyLabel(e.key) }}</span>
                                        <span class="n-value">{{ e.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Notes -->
                        <div class="notes-section" *ngIf="food?.userNotes">
                            <i class="fa-solid fa-note-sticky"></i>
                            <span>{{ food.userNotes }}</span>
                        </div>

                        <!-- Footer -->
                        <div class="card-footer">
                            <div class="metadata-item" [title]="'Meal date'">
                                <i class="fa-solid fa-calendar"></i>
                                <span class="metadata-text">{{ food?.mealDate }}
                                    <ng-container *ngIf="food?.mealTime">· {{ food.mealTime }}</ng-container></span>
                            </div>
                            <div class="metadata-item" [title]="'Source: ' + food?.source">
                                <i class="fa-solid fa-tag"></i>
                                <span class="metadata-text">{{ food?.source || "—" }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Pagination -->
                <div class="pagination-container" *ngIf="!loading && totalPages > 1">
                    <div class="pagination-info">
                        Page {{ currentPage }} of {{ totalPages }}
                    </div>

                    <div class="pagination-controls">
                        <button class="page-btn" [disabled]="currentPage === 1" (click)="goToFirstPage()"
                            title="First page">
                            <i class="fa-solid fa-angles-left"></i>
                        </button>

                        <button class="page-btn" [disabled]="currentPage === 1" (click)="previousPage()"
                            title="Previous page">
                            <i class="fa-solid fa-angle-left"></i>
                            Previous
                        </button>

                        <div class="page-numbers">
                            <button *ngFor="let page of getPageNumbers()" class="page-number-btn"
                                [class.active]="page === currentPage" [class.ellipsis]="page === -1"
                                [disabled]="page === -1" (click)="goToPage(page)">
                                {{ page === -1 ? "..." : page }}
                            </button>
                        </div>

                        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="nextPage()"
                            title="Next page">
                            Next
                            <i class="fa-solid fa-angle-right"></i>
                        </button>

                        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="goToLastPage()"
                            title="Last page">
                            <i class="fa-solid fa-angles-right"></i>
                        </button>
                    </div>

                    <div class="quick-jump">
                        <label>Go to page:</label>
                        <input type="number" [min]="1" [max]="totalPages" [(ngModel)]="jumpToPageNumber"
                            (keyup.enter)="jumpToPage()" class="page-jump-input" />
                        <button class="btn-secondary" (click)="jumpToPage()">Go</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>